module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[87]452.78ef7b8.woff2";